import React from 'react'
import { hasWorldcatLink } from '@chegg-wt/core/utils/searchSources'
import { Region } from '@chegg-wt/core/state/instrumentation/rio/clickstreamInteractions'
import { AppRoute, SourceType } from '@chegg-wt/core/types/core'
import SourceTypeSelect from './SourceTypeSelect'
import SourceSearchBar from './SourceSearchBar'
import * as Styled from './styled'
import SearchBottomContent from './SearchBottomContent'

export interface CitationSearchInputProps {
  sourceType: SourceType
  initialSearchQuery?: string
  onChangeSourceType: (sourceType: SourceType) => void
  onChangeSearchQuery: (searchQuery: string) => void
  onManualCiteClick: (region: Region) => void
  composeRoute?: (sourceType: SourceType) => AppRoute
}

const CitationSearchInput: React.FC<CitationSearchInputProps> = ({
  sourceType,
  initialSearchQuery,
  onChangeSourceType,
  onChangeSearchQuery,
  onManualCiteClick,
  composeRoute,
}) => {
  const isWorldCatSource = hasWorldcatLink(sourceType.id)

  return (
    <Styled.Container>
      <Styled.InputContainer>
        <Styled.SelectContainer>
          <SourceTypeSelect
            composeRoute={composeRoute}
            onChangeSourceType={onChangeSourceType}
            sourceType={sourceType}
          />
        </Styled.SelectContainer>
        <SourceSearchBar
          searchQuery={initialSearchQuery}
          onSearchQueryUpdate={onChangeSearchQuery}
          isWorldCatSource={isWorldCatSource}
          sourceType={sourceType}
        />
      </Styled.InputContainer>
      <SearchBottomContent
        isWorldCatSource={isWorldCatSource}
        onManualCiteClick={onManualCiteClick}
        sourceType={sourceType}
      />
    </Styled.Container>
  )
}

export default CitationSearchInput
